import { WarningOutlined } from "@ant-design/icons";
import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import GetPositionPerformanceObjectivesApi from "../../api/individuals/GetPositionPerformanceObjectivesApi";
import ObjectiveCard from "../cards/ObjectiveCard";
import PageLoader from "../sub/PageLoader";

const { Option } = Select;

function PositionPerformanceObjectives() {
  const [canStart, setCanStart] = useState(false);
  const [canShow, setCanShow] = useState(false);
  const [data, setData] = useState();

  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const proHeight = document.body.clientHeight;
  let curLocation = useLocation();

  useEffect(() => {
    getPositionObjectives();
  }, [curLocation]);

  async function getPositionObjectives() {
    let path = curLocation.pathname;
    let id = path.split("/positions-performance/");
    const apiResponse = await GetPositionPerformanceObjectivesApi(
      id[1],
      perfCycleState.id
    );
    console.log(apiResponse);
    if (apiResponse.message === "success") {
      setData(apiResponse.data);
      if (apiResponse.data.length) {
        setCanShow(true);
      }
    }
    setCanStart(true);
  }

  function renderObjectives() {
    let output = [];

    data?.forEach((plan) => {
      output.push(<ObjectiveCard plan={plan} />);
    });
    return output;
  }

  function showEmptyPlans() {
    return (
      <div
        style={{ height: proHeight - 188 }}
        className="flex justify-center items-center w-full h-full"
      >
        <div className="text-center">
          <div className="text-3xl text-gray-400">
            <WarningOutlined />
          </div>
          <div className="text-xl pri-font text-gray-400">
            No plans available
          </div>
          <div className="mb-3 text-gray-400">No plans added to this unit</div>
        </div>
      </div>
    );
  }

  return canStart ? (
    canShow ? (
      <div className="pb-8">{renderObjectives()}</div>
    ) : (
      showEmptyPlans()
    )
  ) : (
    <PageLoader />
  );
}

export default PositionPerformanceObjectives;
